import React, { Fragment } from 'react';
import { element, number, arrayOf, shape, bool, func } from 'prop-types';
import { schema as addressSchema } from 'components/Address/util';
import ExpandCollapsePanel from 'components/BookSlot/SlotGrid/ExpandCollapsePanel/ExpandCollapsePanel';
import { MappedAddressRows } from 'components/Address/common';
import classnames from 'classnames';
import styles from './AddressBookList.scss';

const AddressBookList = props => {
  const {
    addresses,
    addressCount,
    children = null,
    collapsedChildren = null,
    collapsed,
    onExpand,
    hideExpandCollapse = false,
    canSelectContactAddress = false,
  } = props;

  return (
    <Fragment>
      {hideExpandCollapse ? (
        <Fragment>
          {collapsedChildren}
          <div className={styles.childRow}>{children}</div>
        </Fragment>
      ) : (
        <ExpandCollapsePanel
          {...{
            allowExpandCollapse: true,
            collapsedChildren,
            collapsed,
            onClick: () => {
              if (collapsed) {
                onExpand();
              }
            },
            expandText: 'Show more',
            expandTextAsButton: true,
            testAttribute: 'address-book-show-more',
          }}
          className={addressCount > 10 ? 'myDetailAddressBookLong' : 'myDetailAddressBook'}
        >
          <MappedAddressRows
            {...{
              addresses,
              selectable: false,
              isEditable: true,
              canSelectContactAddress,
            }}
          />
          <div className={classnames(styles.childRow)}>{children}</div>
        </ExpandCollapsePanel>
      )}
    </Fragment>
  );
};
AddressBookList.propTypes = {
  children: element,
  collapsedChildren: element,
  collapsed: bool.isRequired,
  addressCount: number.isRequired,
  onExpand: func.isRequired,
  addresses: arrayOf(shape(addressSchema)).isRequired,
  hideExpandCollapse: bool,
  canSelectContactAddress: bool,
};

export default AddressBookList;
